module.exports = __webpack_public_path__ + "static/media/close_icon.9d5c0b37.png";